import React from 'react';
import { Button, ButtonColor } from 'ui-builder';
import { OAuthProviderType } from 'nekst-api';

interface SettingsErrorStatusProps {
  message: string;
  provider?: OAuthProviderType | null;
  onRetry: () => void;
  onReturnToSettings: () => void;
}

export default function SettingsErrorStatus({
  message,
  provider,
  onRetry,
  onReturnToSettings
}: SettingsErrorStatusProps) {
  const getProviderName = () => {
    switch (provider) {
      case OAuthProviderType.GOOGLE:
        return 'Google';
      case OAuthProviderType.APPLE:
        return 'Apple';
      default:
        return 'OAuth';
    }
  };

  return (
    <div>
      <i
        className="fa fa-exclamation-circle"
        style={{ fontSize: '2rem', marginBottom: '1rem', color: '#dc3545' }}
      />
      <h2 style={{ marginBottom: '1rem', color: '#dc3545' }}>
        Failed to connect {getProviderName()} account
      </h2>
      <p style={{ color: '#666', marginBottom: '2rem' }}>
        {message}
      </p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
        <Button
          text="Try Again"
          color={ButtonColor.GREEN}
          onClick={onRetry}
        />
        <Button
          text="Return to Settings"
          color={ButtonColor.GRAY}
          onClick={onReturnToSettings}
        />
      </div>
    </div>
  );
}